import { render, staticRenderFns } from "./ClassDropdown.vue?vue&type=template&id=e89f53ea&name=classdd&"
import script from "./ClassDropdown.vue?vue&type=script&lang=js&"
export * from "./ClassDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports